import React from 'react';
import { CSSTransition } from 'react-transition-group';
import classnames from 'classnames';

interface LoadingMessageProps {
  loadingClass?: string;
  message?: string;
}

const LoadingMessage: React.FC<LoadingMessageProps> = ({
  loadingClass = '',
  message,
}) => {
  const loadingClassName = classnames('loading-message', loadingClass);
  if (message) {
    return (
      <CSSTransition appear timeout={500}>
        <div className={loadingClassName}>
          <p>{message}</p>
        </div>
      </CSSTransition>
    );
  }
  return (
    <CSSTransition appear={true} timeout={500}>
      <div />
    </CSSTransition>
  );
};

export default LoadingMessage;
